import Vue from 'vue'
import App from './App.vue'
import Api from '@/api/'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa, faCcMastercard, faCcDiscover, faCcJcb, faCcDinersClub, faCcAmex } from '@fortawesome/free-brands-svg-icons'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

window.bugsnagClient = Bugsnag
Bugsnag.start({
  apiKey: '09b86425975e20a293368f9a934ab9e1',
  plugins: [new BugsnagPluginVue()]
})

library.add(
  faPhone,
  faEnvelope,
  faCcVisa,
  faCcMastercard,
  faCcJcb,
  faCcDiscover,
  faCcDinersClub,
  faCcAmex
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Api, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  havebikeClientId: process.env.VUE_APP_CLIENT_ID
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
